import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  // CardBody,
  // CardHeader,
  Col,
  Container,
  // Input,
  // Label,
  Row,
} from "react-bootstrap";
// import { _get, _put } from "../Utils/Helper";
import { useParams, useNavigate } from "react-router-dom";
import useQuery, { _get, _post, _put } from "../../Utils/Helper";
import { Input } from "antd";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { SingleValue } from "react-select";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
// import { Input } from "antd";

export default function ExamsScore() {
  const id = useParams().id;
  const application_no = useQuery().get("application_no");
  const navigate = useNavigate(); 
  const { school_locations } = useSelector((state: RootState) => state.auth);
  

  const _form = {
    mathematics: 0,
    english: 0,
    other_score: 0,
    applicant_id: "",
    name_of_applicant: "",
    last_class: "",
    current_class: '',
  };

  const [form, setForm] = useState(_form);
  const [errors, setErrors] = useState({});
  const [statusColor, setStatusColor] = useState("secondary"); 
  const [statusText, setStatusText] = useState("Assigned"); 
  // const application_no = useQuery().get("application_no");
  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log({ ...form, query_type: "update", statusText, branch: school_locations[0]?.branch_name
    });
    if(!form.current_class) {
      toast.error("Please select current class");
    }
    _post(
      "update_application_form",
      { ...form, application_no, query_type: "update", statusText },
      (res) => {
        // Handle success
        console.log(res);
        if (res.success) {
          toast.success("Assign successfully");
          navigate(`/entrance-exams-score/entrance-exams-score`);
        }
      },
      (err) => {
        // Handle error
        console.log(err);
      }
    );
  };
  const [new_data, setNewData] = useState([]);
  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const getSecScl = useCallback(() => {
    _get(
      `application_list?id=${application_no}&query_type=select_id`,
      (res) => {
        // Handle success response
        console.log(res);
        if (res.data.length) {
          setForm(res.data[0]);
        }
      },
      (err) => {
        // Handle error response
        console.log(err);
      }
    );
  }, [id]);
  const getSelectClassName = () => {
    _get(
      `classes?query_type=select-all`,
      (res) => {
        setNewData(res.data);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    getSecScl();
    getSelectClassName();
  }, [getSecScl]);

  return (
    <div>
      {/* <Container> */}
      <div className="page-wrapper">
        <div className="content content-two"></div>
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="card">
                <div className="card-header bg-light">
                  <div className="d-flex align-items-center">
                    <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                      <i className="ti ti-info-square-rounded fs-16" />
                    </span>
                    <h4 className="text-dark">Class Assignment</h4>
                  </div>
                </div>
                <div className="card-body">
                  <Row>
                    <Col md={12} className="mb-4">
                      <Row>
                        <Col md={4}>
                          <h4>
                            Name:{" "}
                            <span style={{ fontWeight: "500" }}>
                              {form.name_of_applicant}
                            </span>
                          </h4>
                        </Col>
                        <Col md={4}>
                          <h4>
                            Application No:{" "}
                            <span style={{ fontWeight: "500" }}>
                              {form.applicant_id}
                            </span>
                          </h4>
                        </Col>
                        <Col md={4}>
                          <h4>
                            Last Class Attended:{" "}
                            <span style={{ fontWeight: "500" }}>
                              {form.last_class}
                            </span>
                          </h4>
                        </Col>
                      </Row>

                      <div className="col-xxl col-xl-6 col-md-6 mt-4">
                        <div className="mb-3">
                          <label
                            className="form-label font-weight-bold"
                            style={{ fontSize: "18px", fontWeight: "700" }}
                          >
                            Assign Class
                          </label>
                          <CommonSelect
                            className="select"
                            options={new_data?.map((i: any) => ({
                              label: i.class_name,
                              value: i.class_code,
                            }))}
                            handleChange={(newValue: SingleValue<Option>) =>
                              setForm((prev) => ({
                                ...prev,
                                current_class: newValue ? newValue.value : "",
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <Button className="mt-5" onClick={() => navigate(-1)}>
                          Back
                        </Button>
                        <Button
                          className="mt-5"
                          // onClick={() =>
                          //   navigate(
                          //     "/entrance-exams-score/entrance-exams-score"
                          //   )
                          // }
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* </Container> */}
      </div>
    </div>
  );
}
